import { API_BASE_URL } from '../../../../api';
import React, { useState, useEffect,useContext } from "react";
import { AccountContext } from "../../../../Contexts/main.context";

const UpdateUser = ({ user }) => {
     const [formData, setFormData] = useState({
          ID: "",
          displayName: "",
          email: "",
          iconSex: "Male",
          phone: "",
          accountSecurity: "User",
     });

     const [changePassword, setChangePassword] = useState(false);
     const [newPassword, setNewPassword] = useState("");
     const [deleting, setDeleting] = useState(false);
     const [deleteError, setDeleteError] = useState('');
      const { updateActiveOutlet, updateMasked, userAccounts, updateUserAccounts } = useContext(AccountContext)

     const deleteUser = async () => {
          if (deleting || !window.confirm(`Delete ${user.displayName}? This cannot be undone.`)) return;
          setDeleting(true);
          setDeleteError('');
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ script: 'deleteUser', ID: user.ID }),
               });
               const data = await response.json();
               if (!response.ok || data.status !== 'success') {
                    throw new Error(data.message || 'Unable to delete user. Please try again.');
               }
               updateUserAccounts(userAccounts.filter(account => String(account.ID) !== String(user.ID)));
               cancelChange();
          } catch (error) {
               setDeleteError(error.message || 'Unable to delete user. Please try again.');
          } finally {
               setDeleting(false);
          }
     };

     useEffect(() => {
          if (user) {
               setFormData({
                    ID: user.ID || "",
                    displayName: user.displayName || "",
                    email: user.email || "",
                    iconSex: user.iconSex || "Male",
                    phone: user.phone || "",
                    accountSecurity: user.accountSecurity || "User",
               });
          }
     }, [user]);

     const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData((prev) => ({ ...prev, [name]: value }));
     };

     const handleSubmit = async (e) => {
          e.preventDefault();
          const updatedClient = { ...formData, script: "updateUser" };
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(updatedClient),
               });
               const data = await response.json();
               if (data.status === "success") {
                    cancelChange();
               } else {
                    alert(data.message);
               }
          } catch (error) {
               alert("An error occurred Saving User Data");
          }
  
     };

     const cancelChange = () => {
          updateActiveOutlet('Users');
          updateMasked(false);    
     }

     const letsUpdatePassword = async () => {
          const updatedClient = { ...formData, newPassword,  script: "updateUserPassword" };
          console.log(updatedClient);
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(updatedClient),
               });
               const data = await response.json();
               if (data.status === "success") {
                    cancelChange();
               } else {
                    alert(data.message);
               }
          } catch (error) {
               alert("An error occurred Saving User Data");
          }
     };
     // 🔒 Guard clause: Wait for user to be defined and not null

     if (!user)
          return (
               <div className="alert alert-warning text-center mt-4">
                    No user selected for update.
               </div>
          );

     return (
          <div className="col-46 offset-1 mt-4">
               <h3 className="text-center mb-3">Update User: {user.displayName}</h3>
               {deleteError && <div role="alert" className="alert alert-danger">{deleteError}</div>}
               {!changePassword ? (
                    <form onSubmit={handleSubmit} className="p-4 border rounded bg-light">
                         <div className="d-flex gap-2">
                              <div className="mb-3 col-24">
                                   <label className="form-label">Display Name</label>
                                   <input
                                        type="text"
                                        name="displayName"
                                        value={formData.displayName}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   />
                              </div>

                              <div className="mb-3 flex-grow-1">
                                   <label className="form-label">Email</label>
                                   <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                   />
                              </div>
                         </div>

                         <div className="d-flex gap-2">
                              <div className="col-12 mb-3">
                                   <label className="form-label">Icon to Display</label>
                                   <select
                                        name="iconSex"
                                        value={formData.iconSex}
                                        onChange={handleChange}
                                        className="form-select"
                                   >
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                   </select>
                              </div>

                              <div className="col-16 mb-3">
                                   <label className="form-label">Phone</label>
                                   <input
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="form-control"
                                   />
                              </div>

                              <div className="mb-3 col-12">
                                   <label className="form-label">Account Security</label>
                                   <select
                                        name="accountSecurity"
                                        value={formData.accountSecurity}
                                        onChange={handleChange}
                                        className="form-select"
                                   >
                                        <option value="Manager">Manager</option>
                                        <option value="Admin">Admin</option>
                                   </select>
                              </div>

                              <div className="mb-3 flex-grow-1">
                                   <label className="form-label">Change Password</label>
                                   <div
                                        className="btn btn-warning w-100"
                                        onClick={() => setChangePassword(true)}
                                   >
                                        Change Password
                                   </div>
                              </div>
                         </div>

                         <div className="w-100 d-flex gap-3 mt-3">
                              <div className="col-24 d-flex gap-3">
                                   <div className="col-12">
                                        <button type="button" className="btn btn-danger text-light w-100" onClick={deleteUser} disabled={deleting}>
                                             {deleting ? 'Deleting...' : 'Delete User'}
                                        </button>
                                   </div>
                                   <div className="col-12">
                                        <div className="btn btn-danger w-100" onClick={()=>cancelChange()}>Cancel</div>
                                   </div>
                              </div>
                              <div className="ms-auto col-22 d-flex gap-3 justify-content-end">
                                   <div className="col-24">
                                        <button
                                             className="btn btn-success text-light w-100"
                                             type="submit"
                                             disabled={deleting}
                                        >
                                             Save User
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </form>) : (
                    <div className="mt-4 p-3">
                         <div className="w-100 mb-3 alert-light p-2">
                              <div className="text-center fw-bold">It is not recommended to change a users password unless requested.</div>
                               <div className="text-center"> A user can change their own password in their 'My Account' or at the 'Login' by pressing on Forgot My Password.</div>
                         </div>
                         <div className="mb-3 col-24 offset-12">
                              <label className="form-label">New Password</label>
                              <input
                                   type="text"
                                   name="newPassword"
                                   value={newPassword}
                                   onChange={(e) => setNewPassword(e.target.value)}
                                   className="form-control"
                                   placeholder="Enter new password"
                              />
                         </div>
                         <div className="d-flex justify-content-between col-24 offset-12">
                              <button
                                   className="btn btn-success text-light"
                                   onClick={() => {
                                        letsUpdatePassword()
                                        setChangePassword(false);
                                   }}
                                   type="button"
                              >
                                   Yes, Change Password
                              </button>
                              <button
                                   className="btn btn-danger"
                                   onClick={() => setChangePassword(false)}
                                   type="button"
                              >
                                   Cancel
                              </button>
                         </div>
                    </div>
               )}
          </div>
     );
};

export default UpdateUser;
